import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.FileDropProvider', {
    fileTooBigError: 'File size exceeds {maxSize}',
    fileExtensionNotSupportedError: 'Invalid file type',
});
